'use client';
import { useMemo } from 'react';
import { round, unique } from '@s7/utils';

const dynamicMultipliers = (width)=>{
    // Чем больше картинка, тем большее кол-во шагов используем
    if (width < 160) {
        return [
            0.5,
            1,
            2
        ];
    }
    if (width < 750) {
        return [
            0.5,
            1,
            1.5,
            2
        ];
    }
    if (width < 1400) {
        return [
            0.25,
            0.5,
            0.75,
            1,
            1.5,
            2
        ];
    }
    return [
        0.25,
        0.5,
        0.75,
        1,
        1.25,
        1.5,
        1.75,
        2
    ];
};
function useResponsiveImage(options, responsive) {
    const { width = null, height = null, baseUrl = '', src, srcPrefix, loader } = options;
    return useMemo(()=>{
        if (!responsive || !width || !height) {
            const srcUrl = loader ? loader({
                baseUrl,
                srcPrefix,
                src,
                options: {
                    width,
                    height
                }
            }) : src;
            return {
                src: srcUrl
            };
        }
        const srcSetEntries = dynamicMultipliers(width).map((multiple)=>{
            const computedWidth = round(width * multiple);
            const computedHeight = round(height * multiple);
            /*
                 * Для очень маленьких картинок оптимальной стратегией является
                 * загрузка в оригинальном разрешении.
                 * */ if (multiple < 1 && computedWidth < 50) {
                return null;
            }
            const url = loader ? loader({
                baseUrl,
                src,
                srcPrefix,
                options: {
                    width: computedWidth,
                    height: computedHeight,
                    quality: 90
                }
            }) : src;
            return `${url} ${computedWidth}w`;
        }).filter(Boolean);
        return {
            srcSet: unique(srcSetEntries).join(', ')
        };
    }, [
        width,
        height,
        loader,
        baseUrl,
        src,
        srcPrefix,
        responsive
    ]);
}

export { useResponsiveImage };
//# sourceMappingURL=useResponsiveImage.js.map
